import { useQuery } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";

import OrganizationFunctionsService from "src/modules/data-protection/apis/OrganizationFunctionsService";
import {
    ORGANIZATION_FUNCTION_ERROR_CODES,
    extractOrganizationFunction,
    getOrganizationFunctionQueryKey,
    toastOrganizationFunctionError,
} from "src/modules/data-protection/constants/organizationFunctions";
import { ROUTE_PATH_ADMIN_USER_LIST } from "src/modules/data-protection/constants";

const FUNCTIONS_LIST_PATH = `${ROUTE_PATH_ADMIN_USER_LIST}?tab=functions`;

const useOrganizationFunction = (key, t) => {
    const history = useHistory();

    return useQuery({
        queryKey: getOrganizationFunctionQueryKey(key),
        queryFn: async () => {
            const service = OrganizationFunctionsService.getInstance();
            const data = await service.show(key);
            const organizationFunction = extractOrganizationFunction(data);

            if (!organizationFunction) {
                const error = new Error(
                    ORGANIZATION_FUNCTION_ERROR_CODES.NOT_FOUND
                );
                error.response = {
                    status: 404,
                    data: {
                        error: ORGANIZATION_FUNCTION_ERROR_CODES.NOT_FOUND,
                    },
                };
                throw error;
            }

            return organizationFunction;
        },
        enabled: !!key,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            const code = toastOrganizationFunctionError(
                error,
                t,
                "An error occurred while fetching function details."
            );

            if (
                code === ORGANIZATION_FUNCTION_ERROR_CODES.NOT_FOUND ||
                error?.response?.status === 404
            ) {
                history.push(FUNCTIONS_LIST_PATH);
            }
        },
    });
};

export default useOrganizationFunction;
